import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Alert, Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import api from '../../../services/api';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const formatPhoneBR = (value) => {
    let digits = value.replace(/\D/g, '');
    if (!digits.startsWith('55')) digits = `55${digits}`;
    digits = digits.slice(0, 13); // 55 + DDD (2) + numero (9)

    let formatted = '+';
    formatted += digits.slice(0, 2);
    if (digits.length > 2) formatted += ` (${digits.slice(2, 4)}`;
    if (digits.length >= 4) formatted += ') ';
    if (digits.length > 4) formatted += digits.slice(4, 9);
    if (digits.length > 9) formatted += `-${digits.slice(9, 13)}`;

    return formatted;
};

const NovaConversaDialog = ({ open, onClose, appId, onCreated, initialNome = '', initialTelefone = '' }) => {
    const [canal, setCanal] = useState('whatsapp');
    const [nome, setNome] = useState('');
    const [telefone, setTelefone] = useState('+55 (');
    const [email, setEmail] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    // Pré-preenche (ex: "Salvar contato" de uma mensagem de contato
    // recebida) sempre que o diálogo é reaberto - `initialTelefone` chega
    // só em dígitos (extraído do vCard), formata igual o usuário digitando.
    useEffect(() => {
        if (open) {
            setCanal('whatsapp');
            setNome(initialNome || '');
            setTelefone(initialTelefone ? formatPhoneBR(initialTelefone) : '+55 (');
            setEmail('');
            setError('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const handleClose = () => {
        if (saving) return;
        setCanal('whatsapp');
        setNome('');
        setTelefone('+55 (');
        setEmail('');
        setError('');
        onClose();
    };

    const handleChangeTelefone = (e) => {
        setTelefone(formatPhoneBR(e.target.value));
    };

    const handleChangeCanal = (e, novoCanal) => {
        if (!novoCanal) return;
        setCanal(novoCanal);
        setError('');
    };

    const handleSubmit = async () => {
        if (!nome.trim()) {
            setError('Preencha o nome do cliente');
            return;
        }

        let payload;
        if (canal === 'email') {
            const emailLimpo = email.trim();
            if (!EMAIL_REGEX.test(emailLimpo)) {
                setError('Preencha um e-mail válido');
                return;
            }
            payload = { type: 'email', displayName: nome.trim(), email: emailLimpo, state: 'open', create_deal: true };
        } else {
            const somenteDigitos = telefone.replace(/\D/g, '');
            if (somenteDigitos.length < 12) {
                setError('Preencha o telefone completo, com DDD');
                return;
            }
            payload = { type: 'whatsapp', displayName: nome.trim(), phone_number: somenteDigitos, state: 'open', create_deal: true };
        }

        try {
            setSaving(true);
            setError('');

            const response = await api.post(`v1/apps/${appId}/conversations/`, payload);

            onCreated(response.data.conversation);
            handleClose();
        } catch (err) {
            console.error('Erro ao criar nova conversa', err);
            setError(err.response?.data?.error || 'Erro ao criar conversa');
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
            <DialogTitle>Nova conversa</DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2} mt={1}>
                    {error && <Alert severity="error">{error}</Alert>}
                    <ToggleButtonGroup color="primary" value={canal} exclusive onChange={handleChangeCanal} fullWidth size="small">
                        <ToggleButton value="whatsapp">WhatsApp</ToggleButton>
                        <ToggleButton value="email">E-mail</ToggleButton>
                    </ToggleButtonGroup>
                    <TextField
                        label="Nome do cliente"
                        value={nome}
                        onChange={(e) => setNome(e.target.value)}
                        fullWidth
                        autoFocus
                    />
                    {canal === 'email' ? (
                        <TextField
                            label="E-mail do cliente"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            fullWidth
                            placeholder="cliente@exemplo.com"
                        />
                    ) : (
                        <TextField label="Telefone" value={telefone} onChange={handleChangeTelefone} fullWidth placeholder="+55 (11) 91234-5678" />
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={saving}>
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} variant="contained" disabled={saving}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NovaConversaDialog;
